import type { Quadro } from '@praticheenergia/domain'

export interface Posizione {
  readonly quadro?: Quadro
  readonly rigo?: string
  readonly contatoreId?: string
  readonly mese?: number
}

export interface Diagnostica {
  readonly codice: string
  readonly gravita: 'bloccante' | 'avviso'
  readonly messaggio: string
  readonly posizione: Posizione
}

export const bloccante = (codice: string, messaggio: string, posizione: Posizione = {}): Diagnostica => ({
  codice,
  gravita: 'bloccante',
  messaggio,
  posizione,
})

export const avviso = (codice: string, messaggio: string, posizione: Posizione = {}): Diagnostica => ({
  codice,
  gravita: 'avviso',
  messaggio,
  posizione,
})
